angular.module('impactx.dashboard').controller('EditExternalContentCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    EditExternalContentCtrl]);

function EditExternalContentCtrl($scope, $mdDialog, TranslationService) {
    $scope.abortLabel = TranslationService.get("abort");
    $scope.confirmLabel = TranslationService.get("accept");
    var self = this;
    self.url = {value: self.element.url};
    self.height = {value: self.element.height};

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.answer = function () {
        self.element.url = self.url.value;
        self.element.height = self.height.value;
        $mdDialog.hide();
    };
}